export const ListQueryKey = 'projectAccountOperates';
export const DetailQueryKey = 'projectAccountOperate';

export const Urls = {
  selectUrl: '/accountoperatelog/list',
  updateUrl: '/accountoperatelog/update',
  deleteUrl: '/accountoperatelog/delete',
  createUrl: '/accountoperatelog/create',
  detailUrl: '/accountoperatelog/info',
};
